import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ErrorFallback({ error }) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.
    var _a;
    return (_jsxs("div", { role: "alert", children: [_jsx("p", { className: "mb-1 text-lg font-bold", children: "Something went wrong:" }), _jsxs("pre", { className: "text-red-700", children: [(_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "Please refresh the page and try again. If the problem persists, contact support.", " "] })] }));
}
